export default "__VITE_ASSET__meVtfsSt__"